export default "__VITE_ASSET__Clzg9yPM__"